import clsx from "clsx";
import type { ReactNode } from "react";

/** Blog article wrapper — linen background fixed to the viewport while scrolling. */
export function BlogPageSurface({
  children,
  className,
}: Readonly<{
  children: ReactNode;
  className?: string;
}>) {
  return (
    <div
      data-blog-page-surface
      className={clsx("relative bg-blog-page-fixed", className)}
    >
      {children}
    </div>
  );
}
